import React, { useContext } from 'react'
import { CustomContainer } from '../../components/CustomContainer'
import { Box, Button, Stack } from '@mui/material'
import { AppContext } from '../../context/context'
import { Divider } from '../../Divider'
import { useNavigate } from 'react-router-dom'
import { downloadFile } from '../../utils/downloadFile'
const style = {
  display: 'flex',
  justifyContent: 'center', 
  alignItems: 'center',
  flexDirection: 'column',
} 
export const DownloadsFileView = () => {
  const { data } = useContext(AppContext)
  const { files } = data
  const navigate = useNavigate()

  const handleNav = () => {
    navigate('/')
  }
  return (
    <CustomContainer>
      <Divider />
      <Stack  justifyContent="space-around" alignItems="center" width="100%"  direction="row">
        <Box style={style}>
          <img src="/images/xml.png" alt="Descargar XML" style={{
            minWidth: 100,
            maxWidth: 100,
          }} />
          <Button
            variant="text"
            sx={{color: 'white'}}
            onClick={() => downloadFile(files?.cfdiUrl, "cfdi.xml")}
            target="_blank"
          >
            Descargar XML
          </Button> 
        </Box>
        <Box style={style}>
          <img src="/images/pdf.png" alt="Descargar PDF" style={{
            minWidth: 100,
            maxWidth: 100,
          }} />
          <Button 
            variant="text"
            target="_blank" 
            sx={{color: 'white'}} 
            onClick={() => downloadFile(files?.pdfUrl, "factura.pdf")}
            >Descargar PDF</Button>
        </Box>
      </Stack>
      <Button onClick={handleNav} variant="unu-outlined">Volver al inicio</Button>
    </CustomContainer>
  )
}
